<template>
  <div>
    <v-container>
      <v-layout row wrap>
        <v-carousel>
          <v-carousel-item v-for="(slide,index) in sliders" v-bind:src="slide.src" :key="index">
            <h1 :color="slide.style">{{ slide.title }}</h1>
            <div class="title">
            <p>{{ slide.short }}</p>
              <v-btn round dark :color="slide.style" :to="slide.link">Mehr erfahren &raquo;</v-btn>
            </div>
          </v-carousel-item>
        </v-carousel>
      </v-layout>
    </v-container>

    <v-container grid-list-md text-xs-center>
      <v-layout row wrap>
        <v-flex xs4 v-for="(slide,index) in sliders" :key="index">
          <v-card>
            <v-card-text>
              <h2>{{slide.title}}</h2>
              <p>{{slide.text}}</p>
            </v-card-text>
            <v-btn dark round :color="slide.style" :to="slide.link">Mehr erfahren &raquo;</v-btn>
            <v-spacer></v-spacer>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
  export default {
    data () {
      return {
        name: 'HomePage',
        sliders: [{
          title: 'Softwareentwicklung',
          short: 'Individuelle Software oder Standartsoftware genau auf Ihre Bedürfnisse angepasst.',
          text: 'Individuelle Software oder Standartsoftware genau auf Ihre Bedürfnisse angepasst. Auf der Basis unserer umfassenden Erfahrung entwickeln wir schnell, effizient und kostengünstig.',
          src: '/static/images/carousel/slide_a_900x500.jpg',
          style: 'blue',
          link : 'solutions'
        },
        {
          title: 'Beratung',
          short: 'Fachkundige Beratung für optimale Software.',
          text: 'Fachkundige Beratung für optimale Software. Profitieren Sie von unserem Know-How und unserer Marktübersicht bei Fragen und Problemen bei IT-Prozessen und IT-Systemen.',
          src: '/static/images/carousel/slide_b_900x500.jpg',
          style: 'green',
          link : 'consulting'
        },
        {
          title: 'Service',
          short: 'Wir sind für Sie da! Fachkundiger Service bei Problemen und Fragen',
          text: 'Wir sind für Sie da! Hohe Produktqualität und ein optimaler Service gehören zusammen. Neben einer qualifizierten Hotline steht unseren Kunden ein spezieller Supportbereich zur Verfügung.',
          src: '/static/images/carousel/slide_c_900x500.jpg',
          style: 'yellow darken-3',
          link : 'service'
        }
        ]
      }
    }
  }
</script>

<style scoped>
  .title {
    position: absolute;
    bottom: 50px;
    text-align: center;
    background-color: rgba(0,0,0,0.5);
    color: white;
    font-size: 2em;
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue